import React, { useEffect, useMemo, useState } from 'react'
import {
  Container,
  Row,
  Col,
  Form,
  Table,
  Button,
  Modal,
} from 'react-bootstrap'
import axios from 'axios'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import Cookies from 'js-cookie'
import { Typeahead } from 'react-bootstrap-typeahead'
import { FaClipboardList, FaSyncAlt } from 'react-icons/fa'
import toast from 'react-hot-toast'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useAuth } from './AuthContext'

export default function AddExamResult() {
  const {token} =useAuth();
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const { student_id, course_id, class_id } = useParams()
  console.log(
    'Type of student Id: ',
    typeof student_id,
    'Type of Course Id: ',
    typeof course_id,
    class_id,
    'Type of Class Id: ',
    typeof class_id,
  )
  const [courses, setCourses] = useState([])
  const [selectedCourse, setSelectedCourse] = useState('')
  const [exams, setExams] = useState([])
  const [selectedExams, setSelectedExams] = useState('')
  const [classes, setClasses] = useState([])
  const [selectedClass, setSelectedClass] = useState([])
  const [students, setStudents] = useState([])
  const [selectedStudent, setSelectedStudent] = useState('')
  const [openTable, setOpenTable] = useState(false)
  const [subjects, setSubjects] = useState([])
  const [formData, setFormData] = useState([])
  const [viewPreview, setViewPreview] = useState(false)
  const [selectedStudentName, setSelectedStudentName] = useState(false)
  const [disabledMarking, setDisabledMarking] = useState(false)
  const navigate = useNavigate()
  const {institute_id} = useAuth()
  const location = useLocation()
  const editExamData = useMemo(()=>{
    return location.state?.data || []
  },[location.state?.data])

  const selectedExamId = location.state?.selectedExamId
  console.log("Exam Data from Marksheet: ", editExamData)

  useEffect(() => {
    console.log("📌 Triggering formData setup useEffect");
    console.log("✅ editExamData:", editExamData);
    console.log("✅ subjects:", subjects.length);
    console.log("✅ selectedExamId:", selectedExamId);

    
    if (editExamData.length > 0 && subjects.length > 0 && selectedExamId) {
      const updatedFormData = subjects.map((sbj) => {
     
        const match = editExamData.find(
          (item) => item.subject_id === sbj.id && item.exam_id === selectedExamId
        )

        const marks = match?.marks ?? ''
        return {
          subject_id: sbj.id,
          subject_name: sbj.subject_name,
          result_id: match?.id || null,
          number: typeof marks === 'number' || !isNaN(marks) ? String(marks) : '',
          grade: isNaN(marks) ? marks : '',
          status: match?.status || '',
        }
      })
      setFormData(updatedFormData)
    }
  }, [editExamData, subjects, selectedExamId])


  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => {
      console.log('📌 All Courses:', res.data.data)
      setCourses(res.data.data)
    })
  }, [])

  useEffect(() => {
    if (course_id && courses.length > 0) {
      setSelectedCourse(course_id)
      handleCourseChange({ target: { value: course_id } })
    }
  }, [course_id, courses])

  useEffect(() => {
    if (class_id && classes.length > 0) {
      console.log(
        'Classes: ',
        courses,
        ' class_id: ',
        course_id,
        ' -> within useEffect',
      )
      setSelectedClass(Number(class_id))
      handleClassChange({ target: { value: class_id } })
    }
  }, [class_id, classes])

  // useEffect(() => {
  //   if (prevData.length > 0 && subjects.length > 0) {
  //     const updatedFormData = subjects.map((sbj) => {
  //       const match = prevData.find(
  //         (item) =>
  //           item.subject_id === sbj.id && item.exam_id === selectedExamId
  //       )
  
  //       const marks = match?.marks ?? ''
  
  //       return {
  //         subject_id: sbj.id,
  //         subject_name: sbj.subject_name,
  //         result_id: match?.id || null,
  //         number:
  //           typeof marks === 'number' || !isNaN(marks) ? String(marks) : '',
  //         grade: isNaN(marks) ? marks : '',
  //         status: match?.status || '',
  //       }
  //     })
  
  //     setFormData(updatedFormData)
  //   }
  // }, [prevData, subjects, selectedExamId])
  
  useEffect(() => {
    if (student_id && students.length > 0) {
      console.log(
        'Students: ',
        students,
        ' student_id: ',
        course_id,
        ' -> within useEffect',
      )
      const matchedStudent = students.find(
        (st) => Number(st.id) === Number(student_id),
      )
      setSelectedStudentName(matchedStudent?.name)
      if (matchedStudent) {
        setSelectedStudent(Number(student_id))
        // setSelectedStudentName(Number(student_id))
        handleStudentChange({ target: { value: student_id } })
      }
    }
  }, [student_id, students])

  useEffect(() => {
    if (subjects.length > 0 && (!editExamData || editExamData.length === 0)) {
      const initialForm = subjects.map((sbj) => ({
        subject_id: sbj.id,
        number: sbj.number || '',
        grade: sbj.grade || '',
        grade_number: sbj.number || sbj.grade || '',
        status: sbj.status || '',
      }))
      console.log('initialForm', initialForm)
      setFormData(initialForm)
    }
  }, [subjects, editExamData])

  // useEffect(() => {
  //   if (location.state?.data) {
  //     const incomingData = location.state.data
  
  //     // ✅ Ensure all subjects are loaded first
  //     if (subjects.length > 0) {
  //       const updatedFormData = subjects.map((sbj) => {
  //         const match = incomingData.find((item) => item.subject_id === sbj.id)
          
  //         return {
  //           subject_id: sbj.id,
  //           subject_name: sbj.subject_name,
  //           result_id: match?.id || null,
  //           number: match && !isNaN(match.marks) ? match.marks : '', // marks in number
  //           grade: match && isNaN(match.marks) ? match.marks : '',   // marks in grade
  //           status: match?.status || '',
  //         }
  //       })
  
  //       setFormData(updatedFormData)
  //     }
  //   }
  // }, [location.state, subjects])
  
  
  // useEffect(()=>{
  //   if(location.state?.data){
  //     const incomingData = location.state.data
  //     const transformed = incomingData.map((item)=>({
  //       result_id:item.id,
  //       subject_id:item.subject_id,
  //       number:item.number || "",
  //       grade: item.grade || "",
  //       status:item.status || "",
  //     }))
  //     setFormData(transformed)
  //   }
  // },[location.state])

  // useEffect(() => {
  //   if (location.state?.data?.length > 0) {
  //     const firstEntry = location.state.data[0]
  //     setSelectedCourse(firstEntry.course_id)
  //     setSelectedStudent(firstEntry.student_id)
  //     // setSelectedExams(firstEntry.exam_id)
  //     setOpenTable(true)
  //     setDisabledMarking(true)
  //   }
  // }, [location.state])
  useEffect(() => {
    if (selectedExamId) {
      setSelectedExams(selectedExamId)
    }
  }, [selectedExamId])
    
    const handleCourseChange = (e) => {
      const courseId = e.target.value
      console.log('courseId', courseId)
      setSelectedCourse(courseId)
      if (courseId) {
        ApiEndpoints.getAllClassesByCourseId(courseId).then((res) => {
          console.log('Classes after course:', res.data.data)
          setClasses(res.data.data)
        })
      }
      if (courseId) {
        axios
          .get(
            BASE_URL+`/get/all/exam-by-course?course_id=${courseId}`,
            {headers: { Authorization: `Bearer ${token}` }  }
          )
          .then((res) => {
            console.log('all exams after selected course:', res.data.data)
            setExams(res.data.data)
          })
      }
    
      if (courseId) {
        ApiEndpoints.getSubjectsByCourse(courseId).then((res) => {
          console.log('Subjects by course:', res.data.data)
          setSubjects(res.data.data)
        })
      }
    }

    const handleExamChange = (e) => {
      const examId = e.target.value
      console.log('✅ Selected Exam ID:', examId)
      setSelectedExams(examId)
      if (examId) {
        setOpenTable(true)
      }
    }

  const handleClassChange = (e) => {
    const classId = e.target.value
    console.log('Selected class:', classId)
    setSelectedClass(classId)
    if (classId) {
      const institueId = Cookies.get('institute_id')
      const headers = {
        institute_id: institueId || institute_id,
        Authorization: `Bearer ${token}`
      }
      axios
        .get(
          BASE_URL+`/get/student/by-class?class_id=${classId}`,
          { headers },
        )
        .then((res) => {
          console.log('List of Students:', res.data.data)
          setStudents(res.data.data)
        })
    }
  }

  // const handleStudentChange = async (e) => {
  //   const studentId = e.target.value
  //   console.log('✅ Selected Student ID:', studentId)
  //   setSelectedStudent(studentId)
  //   if(prevData?.student_id){
  //     setOpenTable(true)
  //   }
  //   // else if(prevData?.exam_id){
  //   //   setSelectedExams(null)
  //   //   setOpenTable(false)
  //   // }
  //   else{
  //     setOpenTable(true)
  //   }
   
  // }

  
  const handleStudentChange = async (e) => {
    const studentId = e.target.value
    console.log('✅ Selected Student ID:', studentId)
    setSelectedStudent(studentId)
    if(editExamData?.student_id){
      setOpenTable(true)
    }
    else{
      setOpenTable(true)
    }
   
  }

  const handleRefresh = () => {
    setSelectedCourse(null)
    setSelectedExams(null)
    setSelectedClass(null)
    setSelectedStudent(null)
    setSelectedStudentName(null)
    setDisabledMarking(false)
  }

  const handleInputChange = (e, index, type) => {
    const { value } = e.target

    const updatedValue = value.trim()
    const updated = [...formData]
    const passingMarks = selectedExam?.passing_marks || ''
    const scheme = selectedExam?.marking_scheme

    // if(updatedValue === ""){
    //   updated[index]={
    //     number:"",
    //     grade:"",
    //     status:null
    //   }
    //   setFormData(updated)
    //   return
    // }
    let status = updated[index]?.status || null

    if (scheme === 'number') {
      status =
        parseFloat(updatedValue) >= parseFloat(passingMarks) ? 'pass' : 'fail'
      updated[index] = {
        ...updated[index],
        number: updatedValue,
        grade: '',
        status,
      }
    } else if (scheme === 'grade') {
      const gradeOrder = ['A+', 'A', 'B+', 'B', 'C', 'D', 'E', 'F']
      const inputIndex = gradeOrder.indexOf(updatedValue.toUpperCase())
      const passIndex = gradeOrder.indexOf(passingMarks.toUpperCase())

      status = inputIndex <= passIndex && inputIndex !== -1 ? 'pass' : 'fail'
      updated[index] = {
        ...updated[index],
        grade: updatedValue.toUpperCase(),
        number: '',
        status,
      }
    } else if (scheme === 'grade_number') {
      const num = parseFloat(updatedValue)
      const passByNumber = !isNaN(num) && num >= parseFloat(passingMarks)
      const grade = updatedValue.toUpperCase()
      const gradeOrder = ['A+', 'A', 'B+', 'B', 'C', 'D', 'E', 'F']
      const inputIndex = gradeOrder.indexOf(grade)
      const passIndex = gradeOrder.indexOf(passingMarks.toUpperCase())
      const passByGrade = inputIndex <= passIndex && inputIndex !== -1
      if (type === 'number') {
        updated[index] = {
          ...updated[index],
          number: updatedValue,
          grade: '',
          status: passByNumber ? 'pass' : 'fail',
        }
      } else {
        updated[index] = {
          ...updated[index],
          grade: grade,
          number: '',
          status: passByGrade ? 'pass' : 'fail',
        }
      }
    }
    setFormData(updated)
  }
  const handleToggle = (index) => {
    setFormData((prev) => {
      const updated = [...prev]
      const currentStatus = updated[index]?.status || 'pass' // default to pass
      updated[index] = {
        ...updated[index],
        status: currentStatus === 'pass' ? 'fail' : 'pass',
      }
      return updated
    })
  }
  
  const handleSubmit = async (e) => {
    e.preventDefault()
  
    try {
      const putData = []
      const postData = []
  
      formData.forEach((item) => {
        const marks = item.number || item.grade || item.grade_number || null
        const common = {
          exam_id: selectedExams,
          course_id: selectedCourse,
          student_id: selectedStudent,
          subject_id: item.subject_id,
          marks,
          status: item.status || null,
        }
      
        if (item.result_id) {
          putData.push({ ...common, result_id: item.result_id })
        } else {
          postData.push(common)
        }
      })
      
      // 🔁 PUT calls (with token)
      for (const putItem of putData) {
        const userCookie = Cookies.get('user')
        const user = userCookie ? JSON.parse(userCookie) : null
        const token = user?.token
  
        if (!token) {
          toast.error("Authorization token missing for update.")
          return
        }
  
        const putUrl = BASE_URL+`/results/update/${putItem.result_id}`
        const response = await axios.put(putUrl, putItem, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        })
        console.log('PUT response:', response.data)
      }
  
      if (postData.length > 0) {
        const addPayload = {
          exam_id: selectedExams,
          course_id: selectedCourse,
          student_id: selectedStudent,
          subjects: postData
        }
      
        
        const response = await ApiEndpoints.addStudentExamResult( addPayload)
  
        console.log('POST response:', response.data)
      }
  
      toast.success("Exam results submitted successfully.")
      setViewPreview(false)
    } catch (error) {
      const errorData = error.response?.data
      let errorMessage = 'Something went wrong. Please try again.'
  
      if (errorData?.errors) {
        errorMessage = Object.entries(errorData.errors)
          .map(([field, message]) => `${field} - ${message.join(', ')}`)
          .join(' | ')
      } else if (errorData?.message) {
        errorMessage = errorData.message
      }
  
      toast.error(errorMessage)
    }
  }
  
  // const handleSubmit = async (e) => {
  //   e.preventDefault()
  
  //   try {
  //     const putData = []
  //     const postData = []
  
  //     formData.forEach((item) => {
  //       const marks = item.number || item.grade || item.grade_number || null
  //       const common = {
  //         exam_id: selectedExams,
  //         course_id: selectedCourse,
  //         student_id: selectedStudent,
  //         subject_id: item.subject_id,
  //         marks,
  //         status: item.status || null,
  //       }
      
  //       if (item.result_id) {
  //         putData.push({ ...common, result_id: item.result_id })
  //       } else {
  //         postData.push(common)
  //       }
  //     })
      
  //     // 🔁 PUT calls (with token)
  //     for (const putItem of putData) {
  //       const userCookie = Cookies.get('user')
  //       const user = userCookie ? JSON.parse(userCookie) : null
  //       const token = user?.token
  
  //       if (!token) {
  //         toast.error("Authorization token missing for update.")
  //         return
  //       }
  
  //       const putUrl = `https://ttaapi.vibhumsoftware.com/api/results/update/${putItem.result_id}`
  //       const response = await axios.put(putUrl, putItem, {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           'Content-Type': 'application/json',
  //         },
  //       })
  //       console.log('PUT response:', response.data)
  //     }
  
  //     if (postData.length > 0) {
  //       const addPayload = {
  //         exam_id: selectedExams,
  //         course_id: selectedCourse,
  //         student_id: selectedStudent,
  //         subjects: postData
  //       }
      
        
  //       const response = await ApiEndpoints.addStudentExamResult( addPayload)
  
  //       console.log('POST response:', response.data)
  //     }
  
  //     toast.success("Exam results submitted successfully.")
  //     setViewPreview(false)
  //   } catch (error) {
  //     const errorData = error.response?.data?.message
  //     let errorMessage = 'Something went wrong. Please try again.'
  
  //     if (errorData?.errors) {
  //       errorMessage = Object.entries(errorData.errors)
  //         .map(([field, message]) => `${field} - ${message.join(', ')}`)
  //         .join(' | ')
  //     } else if (errorData?.message) {
  //       errorMessage = errorData.message
  //     }
  
  //     toast.error(errorMessage)
  //   }
  // }
  


  const formateScheme = (scheme) => {
    switch (scheme) {
      case 'grade':
        return 'Grade'
      case 'grade_number':
        return 'Grade and Number'
      case 'number':
        return 'Number'
      default:
        return ''
    }
  }

  const handleViewResult = () => {
    navigate(
      `/ExamMarksheet/${selectedStudent}/${selectedCourse}/${selectedClass}`,
    )
  }

  const selectedExam = exams.find((exam) => exam.id === Number(selectedExams))
  console.log('selectedExam', selectedExam)
  const markingScheme = selectedExam?.marking_scheme

  return (
    <>
      <div style={{ marginLeft }}>
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 768 ? '55px' : '-12px',
          }}
        >
          <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
            <h2 className="m-0">
              Create{' '}
              <span className="text-warning">
                {selectedStudentName ? `${selectedStudentName}'s` : ''}
              </span>{' '}
              Marksheet
            </h2>
          </div>
        </div>

        <Row className="align-items-end g-3 mt-3 text-start fw-bold">
          <Col>
            <Form.Group controlId="courseId">
              <Form.Label>Select Course</Form.Label>
              <Typeahead
                id="course-select"
                labelKey="name"
                placeholder="Select Course"
                onChange={(selected) => {
                  const course = selected[0]
                  if (course) {
                    handleCourseChange({ target: { value: course.id } })
                  } else {
                    handleCourseChange({ target: { value: '' } })
                  }
                }}
                options={courses}
                selected={courses.filter(
                  (crs) => crs.id === Number(selectedCourse),
                )}
              />
            </Form.Group>
          </Col>

          <Col>
            <Form.Group>
              <Form.Label>Select class</Form.Label>
              <Typeahead
                id="class-select"
                labelKey="class_name"
                onChange={(selected) => {
                  const cls = selected[0]
                  if (cls) {
                    handleClassChange({ target: { value: cls.id } })
                  } else {
                    handleClassChange({ target: { value: '' } })
                  }
                }}
                options={classes}
                placeholder="Select Class"
                // selected={classes.filter((cls) => cls.id === selectedClass)}
                selected={classes.filter(
                  (cls) => Number(cls.id) === Number(selectedClass),
                )}
              />
            </Form.Group>
          </Col>

          <Col md={3}>
            <Form.Group>
              <Form.Label>Select Student</Form.Label>
              <Typeahead
                id="class-select"
                labelKey={(option) =>
                  `${option.name} - ${option.admission_number}` || ''
                }
                onChange={(selected) => {
                  const std = selected[0]
                  if (std) {
                    handleStudentChange({ target: { value: std.id } })
                  } else {
                    handleStudentChange({ target: { value: '' } })
                  }
                }}
                options={students}
                placeholder="Select Student"
                selected={
                  selectedStudent
                    ? students.filter(
                        (st) => Number(st.id) === Number(selectedStudent),
                      )
                    : []
                }
                // selected={students.filter((std) => std.id === selectedStudent)}
              />
            </Form.Group>
          </Col>
          <Col xs="auto">
            <Button
              variant="outline-primary"
              onClick={handleRefresh}
              title="Refresh"
              className="mt-3"
            >
              <FaSyncAlt />
            </Button>
          </Col>
        </Row>

        <Row className="mt-3 d-flex align-items-center flex-wrap">
          <Col xs={12} md={6} lg={4} className="pe-3">
            <Form.Group className="text-start">
              <Form.Label className="fw-bold">Select Exam</Form.Label>
              <Typeahead
                id="class-select"
                labelKey="exam_name"
                onChange={(selected) => {
                  const exm = selected[0]
                  if (exm) {
                    handleExamChange({ target: { value: exm.id } })
                    setDisabledMarking(true)
                  } else {
                    handleExamChange({ target: { value: '' } })
                    setDisabledMarking(true)
                  }
                }}
                options={exams}
                placeholder="Select Exam"
                selected={exams.filter(
                  (exm) => exm.id === Number(selectedExams),
                )}
              />
            </Form.Group>
          </Col>
          {/* {disabledMarking && (
            <>
              <Col xs="auto" className="d-flex align-items-center pe-3">
                <p className="mb-0">
                  <strong>Marking Scheme</strong>&nbsp;{' '}
                  {formateScheme(
                    exams.find((exm) => exm.id === Number(selectedExams))
                      ?.marking_scheme,
                  ) || '_'}
                </p>
              </Col>
              <Col xs="auto" className="d-flex align-items-center pe-3">
                <p className="mb-0">
                  <strong>Passing Marks : </strong>&nbsp;{' '}
                  {exams.find((exm) => exm.id === Number(selectedExams))
                    ?.passing_marks ?? '__'}
                </p>
              </Col>
              <Col xs="auto" className="d-flex align-items-center">
                <Button
                  variant="link"
                  className="text-decoration-none fw-bold"
                  onClick={handleViewResult}
                >
                  [ <FaClipboardList /> View {selectedStudent?.name} Marksheet ]
                </Button>
              </Col>
            </>
          )} */}
          {(disabledMarking || selectedExamId) && (
            <>
              <Col xs="auto" className="d-flex align-items-center pe-3">
                <p className="mb-0">
                  <strong>Marking Scheme</strong>&nbsp;{' '}
                  {formateScheme(
                    exams.find((exm) => exm.id === Number(selectedExams))
                      ?.marking_scheme,
                  ) || '_'}
                </p>
              </Col>
              <Col xs="auto" className="d-flex align-items-center pe-3">
                <p className="mb-0">
                  <strong>Passing Marks : </strong>&nbsp;{' '}
                  {exams.find((exm) => exm.id === Number(selectedExams))
                    ?.passing_marks ?? '__'}
                </p>
              </Col>
              <Col xs="auto" className="d-flex align-items-center">
                <Button
                  variant="link"
                  className="text-decoration-none fw-bold"
                  onClick={handleViewResult}
                >
                  [ <FaClipboardList /> View {selectedStudent?.name} Marksheet ]
                </Button>
              </Col>
            </>
          )}

        </Row>
        {openTable &&  selectedStudent && subjects.length > 0 && (
          <div className="mt-3">
            <Container>
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>S.NO</th>
                    <th>Subject</th>
                    {(markingScheme === 'number' ||
                      markingScheme === 'grade_number') && (
                      <th>Marks in Number</th>
                    )}

                    {(markingScheme === 'grade' ||
                      markingScheme === 'grade_number') && (
                      <th>Marks in Grade</th>
                    )}
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {subjects.map((item, index) => (
                    <tr className="text-start" key={item.id}>
                      <td>{index + 1}</td>
                      <td>{item.subject_name}</td>
                      {(markingScheme === 'number' ||
                        markingScheme === 'grade_number') && (
                        <td>
                          <Form.Control
                            type="number"
                            placeholder="Enter marks in number"
                            value={formData[index]?.number?.trim() || ""}
                            disabled={!!formData[index]?.grade || ""}
                            onChange={(e) =>
                              handleInputChange(e, index, 'number')
                            }
                          />
                        </td>
                      )}
                      {(markingScheme === 'grade' ||
                        markingScheme === 'grade_number') && (
                        <td>
                          <Form.Control
                            type="text"
                            placeholder="Enter marks in grade"
                            value={formData[index]?.grade?.trim() ||""}
                            disabled={!!formData[index]?.number}
                            onChange={(e) =>
                              handleInputChange(e, index, 'grade')
                            }
                          />
                        </td>
                      )}
                      <td>
                        <Form.Check
                          type="switch"
                          id={`switch-${index}`}
                          label={
                            formData[index]?.status === 'pass' ? 'Pass' : 'Fail'
                          }
                          checked={formData[index]?.status === 'pass'}
                          disabled
                          onChange={() => handleToggle(index)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="d-grid">
                <Button
                  variant="info"
                  className="text-white fw-bold rounded-3 py-2"
                  onClick={() => setViewPreview(true)}
                  style={{ letterSpacing: '2px', fontSize: '20px' }}
                >
                  Show Preview
                </Button>
              </div>
            </Container>
          </div>
        )}
      </div>

      <Modal size="xl" show={viewPreview} onHide={() => setViewPreview(false)}>
        <Modal.Header className="bg-info" closeButton>
          <Modal.Title className="text-white">Preview Marksheet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>S. No</th>
                <th>Subject</th>
                {(markingScheme === 'number' ||
                  markingScheme === 'grade_number') && <th>Marks in Number</th>}

                {(markingScheme === 'grade' ||
                  markingScheme === 'grade_number') && <th>Marks in Grade</th>}
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {subjects.map((item, index) => (
                <tr className="text-start" key={item.id}>
                  <td> {index + 1} </td>
                  <td>{item.subject_name || '-'} </td>
                  {/* <td>{formData[index]?.number || '-'}</td>
                  <td>{formData[index]?.grade || '-'}</td> */}
                  {(markingScheme === 'number' ||
                    markingScheme === 'grade_number') && (
                    <td>{formData[index]?.number?.trim() || '-'}</td>
                  )}
                  {(markingScheme === 'grade' ||
                    markingScheme === 'grade_number') && (
                    <td>{formData[index]?.grade?.trim() || '-'}</td>
                  )}

                  <td>
                    {formData[index]?.status
                      ? formData[index].status.charAt(0).toUpperCase() +
                        formData[index].status.slice(1)
                      : '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <Modal.Footer>
            <Button variant="secondary" onClick={() => setViewPreview(false)}>
              Edit Marksheet
            </Button>
            <Button
              variant="info"
              className="text-white"
              onClick={handleSubmit}
            >
              Save Student Result{' '}
            </Button>
          </Modal.Footer>
        </Modal.Body>
      </Modal>
    </>
  )
}

